import { render, staticRenderFns } from "./arrivalList.vue?vue&type=template&id=d70f2752&scoped=true&"
import script from "./arrivalList.vue?vue&type=script&lang=js&"
export * from "./arrivalList.vue?vue&type=script&lang=js&"
import style0 from "./arrivalList.vue?vue&type=style&index=0&id=d70f2752&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70f2752",
  null
  
)

export default component.exports